// import ScrollMagic from 'scrollmagic';
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

const parallax = (element,target,options) => {

  const elements = [
    {
      wrapper: '.hero',
      bg: '.hero__bg',
      y: '80%'
    },
    {
      wrapper: '.leisure-sea__wrapper',
      bg: '.leisure-sea__bg',
      y: '80%'
    },
    {
      wrapper: '.leisure-mountain__wrapper',
      bg: '.leisure-mountain__bg',
      y: '64%'
    },
    {
      wrapper: '.event__wrapper',
      bg: '.event__bg',
      y: '80%'
    },
    {
      wrapper: '.tourism-contents__wrapper',
      bg: '.tourism-contents__bg',
      y: '64%'
    },
    {
      wrapper: '.greentown-contents__wrapper',
      bg: '.greentown-contents__bg',
      y: '80%'
    }
  ]

  const setScene = (elements) => {
    elements.forEach(function(element){
      let scene = new ScrollMagic.Scene({triggerElement: element.wrapper});
      scene.setTween(element.bg, {y: element.y, ease: Linear.easeNone})
      .addTo(controller);
      $(element.bg).css('top','-40%');
      // .addIndicators()
      // scene.setTween(TweenLite.fromTo(element.bg, 1, {y: '-80%'}, {y: element.y, ease: Linear.easeNone}))
    });
  }

  const controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 'onEnter', duration: '200%'}});

  setScene(elements);

}

export default parallax;